import { render, staticRenderFns } from "./KaitouPdfUpload.vue?vue&type=template&id=4ea99c43&"
import script from "./KaitouPdfUpload.vue?vue&type=script&lang=ts&"
export * from "./KaitouPdfUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports